import { render, staticRenderFns } from "./ProjectList.vue?vue&type=template&id=6570305c"
import script from "./ProjectList.vue?vue&type=script&lang=ts"
export * from "./ProjectList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectList.vue?vue&type=style&index=0&id=6570305c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports